import { normalizeNumber } from '@loggi/js/formatters';
import Button from '@loggi/ui/components/button';
import Col from '@loggi/ui/components/col';
import Text, { TEXT_SIZE_SMALL } from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import View from '@loggi/ui/components/view';
import getStatusPath from 'app/app.utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AuthInput from 'shared/auth/auth-input/auth-input.component';
import { MUTATION_ERROR_MESSAGE } from 'shared/auth/auth.constants';
import authService from 'shared/auth/auth.service';
import { MASKED_CPF_LENGTH } from 'shared/formatters/cpf-cnpj';
import { PATH_PACKAGE_BLOCKED_SCREEN, EDIT_ADDRESS } from 'tracker.routes';
import styles from './auth-card.styles.scss';

export const TITLE = 'Saiba mais informações sobre a sua entrega.';
export const AUTH_CARD_BUTTON = 'auth-card-btn';

class AuthCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidCpfOrCnpj: false,
      cpfOrCnpjNotFound: false,
      inputErrorText: null,
      remainingAttempts: null,
      isLoadingButton: false
    };
  }

  _onChangeAuthCard = inputNifValue => {
    return this.setState({
      inputNifValue,
      invalidCpfOrCnpj: false,
      cpfOrCnpjNotFound: false,
      inputErrorText: null,
      isLoadingButton: false,
      remainingAttempts: null
    });
  };

  _onSuccessAuthentication = ({ packageTrackerAuthentication }) => {
    const { history, packageId } = this.props;
    const { remainingAttempts, success } = packageTrackerAuthentication;

    this.setState({ isLoadingButton: false, remainingAttempts }, () => {
      if (!success) {
        if (remainingAttempts === 0) {
          history.push(PATH_PACKAGE_BLOCKED_SCREEN);
        }
        return this._onFailureAuthentication();
      }

      const root = getStatusPath(packageId);

      // verify if there is query string
      const queryString = history.location.search;

      if (queryString) {
        return history.push(`${root}/${EDIT_ADDRESS}${queryString}`);
      }

      return history.push(`${root}/${EDIT_ADDRESS}`);
    });
  };

  _onFailureAuthentication = () => {
    this.setState(
      {
        isLoadingButton: false,
        cpfOrCnpjNotFound: true,
        inputErrorText: MUTATION_ERROR_MESSAGE
      },
      () => {}
    );
  };

  _onClickAuthCard = () => {
    const { packageId } = this.props;
    const { inputNifValue } = this.state;
    const onSuccess = this._onSuccessAuthentication;
    const onFailure = this._onFailureAuthentication;
    this.setState({ isLoadingButton: true });
    return authService.authenticate(
      packageId,
      normalizeNumber(inputNifValue),
      onSuccess,
      onFailure
    );
  };

  _onKeyPress = e => {
    const isEnterEnabled = !this._shouldDisableButton();

    if (e.key === 'Enter' && isEnterEnabled) {
      e.preventDefault();
      this._onClickAuthCard();
    }
  };

  _shouldDisableButton = () => {
    const { inputNifValue, invalidCpfOrCnpj, cpfOrCnpjNotFound } = this.state;

    return (
      !inputNifValue ||
      invalidCpfOrCnpj ||
      cpfOrCnpjNotFound ||
      inputNifValue.length < MASKED_CPF_LENGTH
    );
  };

  render() {
    const { mainAddress } = this.props;
    const {
      invalidCpfOrCnpj,
      cpfOrCnpjNotFound,
      inputErrorText,
      remainingAttempts,
      isLoadingButton
    } = this.state;

    const inputBlockStyles = remainingAttempts
      ? `${styles.authInputBlock} has-remaining-attemps`
      : styles.authInputBlock;

    return (
      <View flexDirection="column" gutter={{ top: 'onehalf' }}>
        <Text color={colors.type.SMOKE_700} size={TEXT_SIZE_SMALL}>
          {TITLE}
        </Text>
        <Text bold color={colors.type.SMOKE_900}>
          {mainAddress}
        </Text>

        <Col className={inputBlockStyles}>
          <Col>
            <AuthInput
              invalidCpfOrCnpj={invalidCpfOrCnpj}
              cpfOrCnpjNotFound={cpfOrCnpjNotFound}
              inputErrorText={inputErrorText}
              remainingAttempts={remainingAttempts}
              onChange={this._onChangeAuthCard}
              onKeyPress={this._onKeyPress}
            />
          </Col>
          <Button
            data-testid={AUTH_CARD_BUTTON}
            style="primary"
            icon={icons.type.ARROW_FORWARD}
            shape="circle"
            onClick={this._onClickAuthCard}
            isLoading={isLoadingButton}
            disabled={this._shouldDisableButton()}
          />
        </Col>
      </View>
    );
  }
}

AuthCard.displayName = 'AuthCard';

AuthCard.propTypes = {
  mainAddress: PropTypes.string,
  history: PropTypes.func.isRequired,
  packageId: PropTypes.number.isRequired
};

AuthCard.defaultProps = {
  mainAddress: ''
};

export default AuthCard;
